import Noun from '../core/Noun';
import GenericError from "../errors/GenericError";
import Configuration from './Configuration';

class Connection extends Noun {
    constructor(args = {}) {
        const { data = {} } = args;
        const { authToken } = data;

        if (typeof authToken !== "string") {
          throw new GenericError('invalid-prop', `Expected authToken to be a string.`);
        }

        super(args);
    }

    id() {
        return this.attr('authToken');
    }

    getAuthToken() {
      return this.attr('authToken');
    }

    getCookies() {
      return this.getAuthToken().split(';');
    }

    getCookieValue(cookieName) {
      const cookies = this.getCookies();

      for (let i = 0; i < cookies.length; i++) {
        const [name, value] = cookies[i].split('=');
        if (name === cookieName) {
          return value;
        }
      }

      return undefined;
    }

    deleteCookie(cookieName) {
      const cookies = this.getCookies();

      const filteredCookies = cookies.filter(v => {
        const [name, val] = v.split('=');
        return name !== cookieName;
      });

      const updatedCookieHeader = filteredCookies.join(';');

      this.attr('authToken', updatedCookieHeader);

      return this;
    }

    mergeCookies(cookieString) {
      if (!cookieString) {
        return;
      }

      const newCookies = cookieString.split(';')
      const existingCookies = this.getCookies();

      const allCookies = [...existingCookies, ...newCookies];

      const cookieMap = allCookies.reduce((acc, curr) => {
        const [k, v] = curr.split('=');
        acc[k] = v;

        return acc;
      }, {});

      const mergedCookieString = Object.entries(cookieMap).reduce((acc, [k, v]) => {
        if (v) {
          acc.push(`${k}=${v}`)
        } else {
          acc.push(k);
        }

        return acc;
      }, []).join(';');

      this.attr('authToken', mergedCookieString);
    }
}

export default Connection;
